import { omit } from 'lodash';

import adjustUrlParams from './adjustUrlParams';

const removeParamsFromUrl = (url, paramsToRemove = []) => {
  return adjustUrlParams(
    currentParams => omit(currentParams, paramsToRemove),
    url
  );
};

export default removeParamsFromUrl;
